const moment = require('moment');

export const formatDate = (date) => moment(date || new Date()).format().substring(0, 10);

export const nextDay = (date) => {
    const dateMoment = moment(date);
    const increment = dateMoment.isoWeekday() === 5 ? 3 : 1;
    return dateMoment.add(increment, 'days');
};
